import { USER_SESSION_SERVICE_NAME } from "../../../services/user-session"
import { IMRBaseComponent } from "../base"
import { DateRangeSelectorController } from "./date-range-selector.controller"

//#region Asset Imports

import './date-range-selector.scss'
import * as TEMPLATE from './date-range-selector.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'dateRangeSelector'

export class DateRangeSelectorComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: DateRangeSelectorController,
            services: [USER_SESSION_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}